import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '@/domain/store';

import { selectUserLicensesMap } from '../auth/auth.selectors';
import { LicenseMode } from '../auth/entities/user.entity';

export const selectIsFetchingProjectsTour = (state: RootState) => {
  return state.projectTour.isFetchingProjects;
};

export const selectIsCreatingProjectTour = (state: RootState) => {
  return state.projectTour.isCreatingProject;
};

export const selectProjectTourItems = (state: RootState) => {
  return state.projectTour.items;
};

export const selectCurrentProjectTour = (state: RootState) => {
  return state.projectTour.current;
};

export const selectIsEditingProjectTour = (state: RootState) => {
  return state.projectTour.isEditingProject;
};

export const selectProjectTourItemsLength = (state: RootState) => {
  return state.projectTour.items.length;
};

export const checkUserCreateTour = createSelector(
  [selectProjectTourItemsLength, selectUserLicensesMap],
  (nbProjectTour, userLicensesMap) => {
    const licenseFound = userLicensesMap.get(LicenseMode.TOUR);
    return licenseFound && licenseFound.nbProjects > nbProjectTour;
  },
);
